import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const useOperacoesNavegacao = () => {
  const history = useHistory(); // Função para navegar para detalhes/edição (clique na linha)

  const handleRowClick = useCallback(row => {
    console.log('🖱️ Clicou na linha:', row);
    history.push(`/pages/operacoes/detalhes/${row.id}`);
  }, [history]); // Função para navegar para criação

  const handleAdicionar = useCallback(() => {
    console.log('➕ Botão adicionar clicado');
    history.push('/pages/operacoes/criar');
  }, [history]); // Função para navegar para edição

  const handleEditar = useCallback(id => {
    console.log('✏️ Editando operação:', id);
    history.push(`/pages/operacoes/editar/${id}`);
  }, [history]);
  return {
    handleRowClick,
    handleAdicionar,
    handleEditar
  };
};
